export default "__VITE_ASSET__BYxn$M2Y__"